module.exports = __webpack_public_path__ + "img/user_return.369d18e9.svg";